module.exports = __webpack_public_path__ + "static/media/sneakers.538bd983.jpg";